import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { IID_PRATICA_IRU_PROVIDER } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDPraticaIruProviderState extends EntityState<IID_PRATICA_IRU_PROVIDER, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_PRATICA_IRU_PROVIDER , realtimeEntity: 'IID_PraticaIruProvider'})
@InterfaceDataStore(InterfaceName.IID_PRATICA_IRU_PROVIDER)
export class IIDPraticaIruProviderStore extends EntityStore<IIDPraticaIruProviderState> {
  constructor() {
    super([]);
  }
}
